angular
	.module 'App.Service'
	.factory 'translate',
		[
			'$translate',
			($translate) ->
				###
				  @param {string|array} message A token which represents a translation id
				      This can be optionally an array of translation ids which
				      results that the function's promise returns an object where
				      each key is the translation id and the value the translation.
				  @param {object=} [parameters={}] Params
				  @param {string=} [language=false] A language to be used instead of the current language
				  @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
				###
				return (message, parameters, language, sanitizeStrategy) ->
					if _.isEmpty(message)
						return ''

					result = $translate.instant(message, parameters, undefined, language, sanitizeStrategy)

					if typeof result != 'string'
						return result.toString()

					return result
		]
